import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  computed,
  inject,
  input,
  LOCALE_ID,
  signal,
} from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { ProductService } from '../../../../services/product/product.service';
import { ErrorVTO, ProductConfigVTO } from '../../../../pages/admin-dashboard/products/product.model';
import { Loading } from '../../../../utils/loading/loading';
import { Error } from '../../../public-user-component/auth/shared/error/error';
import { ProductConfigVat } from './product-config-vat/product-config-vat';
import { ProductConfigForm } from './product-config-form/product-config-form';
import { ProductConfigView } from './product-config-view/product-config-view';

@Component({
  selector: 'app-product-configuration',
  standalone: true,
  imports: [ProductConfigVat, ProductConfigForm, ProductConfigView, Loading, Error],
  templateUrl: './product-configuration.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductConfiguration implements OnInit, OnDestroy {
  productId = input.required<number>();

  private productService = inject(ProductService);
  private locale = inject(LOCALE_ID);
  private sub = new Subscription();

  isArabic = computed(() => this.locale.startsWith('ar'));

  config = signal<ProductConfigVTO | null>(null);
  isLoading = signal(true);
  apiError = signal('');
  editing = signal(false);

  hasLimits = computed(() => {
    const c = this.config();
    return !!c && (c.orderLimitQuantity != null || c.orderLimitDays != null || c.orderLimitTotalCash != null);
  });

  ngOnInit() {
    this.load();
  }

  load() {
    this.isLoading.set(true);
    this.apiError.set('');
    this.sub.add(
      this.productService
        .getProductConfig(this.productId())
        .pipe(finalize(() => this.isLoading.set(false)))
        .subscribe({
          next: (c) => this.config.set(c),
          error: (err: ErrorVTO) =>
            this.apiError.set(
              this.isArabic() ? err?.messageAr || 'حدث خطأ ما' : err?.messageEn || 'Some error occurred',
            ),
        }),
    );
  }

  onVatChanged(c: ProductConfigVTO) {
    this.config.set(c);
  }

  onLimitsSaved(c: ProductConfigVTO) {
    this.config.set(c);
    this.editing.set(false);
  }

  onEditRequested() {
    this.editing.set(true);
  }

  onEditCancelled() {
    this.editing.set(false);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
